import React, { useContext } from "react";
import { config } from "../../config";
import AppStoreIcon from "../../assets/svgs/app-store-zipmex.svg";
import GooglePlayIcon from "../../assets/svgs/play-store-zipmex.svg";
import MenuArrowIcon from "../../assets/svgs/menu-arrow-next.svg";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import cx from "classnames";

const HomeHero = ({ content, heroCryptoRev, heroImage }) => {
  const { lang, t } = useContext(CustomI18nextContext);
  const { acfHeroSections } = heroCryptoRev || {};

  const revolution = !!acfHeroSections;
  if (revolution) {
    // switch to Crypto Revolution if HeroContent is defined
    content = acfHeroSections;
  }
  return (
    <>
      {content && (
        <div
          id="home-hero"
          className={cx("home mb-5", `lang-${lang}`, { revolution })}
        >
          <div className="container grid-container pt-5 px-3">
            <div
              className={cx("grid-col-12 align-self-center", {
                "grid-col-lg-6": !revolution,
                "grid-col-lg-7": revolution,
              })}
            >
              <h1
                dangerouslySetInnerHTML={{
                  __html: content.hsMainHeading,
                }}
              />
              {content.hsSubHeading && (
                <h2
                  className="text-mt"
                  dangerouslySetInnerHTML={{
                    __html: content.hsSubHeading,
                  }}
                />
              )}
              <div
                className={cx("main-text", { "mt-4": !revolution })}
                dangerouslySetInnerHTML={{
                  __html: content.hsMainText,
                }}
              />
              <div className="text-mt">
                <a
                  className="button button-lime"
                  href={content.hsButtonLink}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="d-flex justify-content-center align-items-center">
                    {content.hsButtonText}
                    <MenuArrowIcon className="ml-3" />
                  </div>
                </a>
              </div>
              <div className="download-apps">
                <a
                  href={config.appDownloadUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  <GooglePlayIcon className="mb-2 w-100 app-play" />
                </a>
                <a
                  href={config.appDownloadUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  <AppStoreIcon className="mb-2 w-100 app-store" />
                </a>
              </div>
              {revolution && <div className="tnc">{t("home.tnc")}</div>}
            </div>

            {!revolution && (
              <div className="d-none d-lg-block grid-col-lg-6 text-right">
                <img
                  src={heroImage}
                  className="hero-image"
                  width="576"
                  height="669"
                  alt=""
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HomeHero;
